/** @jsx jsx */
import { jsx } from '@emotion/react';
import type { TrackEvent } from './types';
import { useAlertBanner } from './useAlertBanner/useAlertBanner';
import { Currency } from '@zapier/currency';
import { useQueryGetCurrencies } from '../../hooks';

type Props = {
  /**
   * Function to track user events when they occur.
   */
  trackEvent: TrackEvent;
};

/**
 * The banner that renders above `UniversalNav` for important alerts.
 */
export const AlertBanner = (props: Props) => {
  const { Component, data: alertBannerData } = useAlertBanner();

  const {
    data: currenciesData,
    isLoading: isLoadingCurrencies,
    isError: isErrorCurrencies,
  } = useQueryGetCurrencies();

  if (
    !Component ||
    isLoadingCurrencies ||
    isErrorCurrencies ||
    !alertBannerData ||
    !currenciesData
  ) {
    return null;
  }

  const targetCurrency = currenciesData.find(
    (c: Currency) => c.name === alertBannerData?.currentAccount.currency
  );

  return (
    <Component
      data={alertBannerData}
      currency={targetCurrency}
      layout="banner"
      trackEvent={props.trackEvent}
    />
  );
};
